<div class="modal fade" #GetproModal tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="border-0 float-end">
                <div class="row">
                    <div class="col d-flex align-items-center">
                        <img class="logo" src="../../../assets/icons/icon-pro-active-hover.png" alt="Gyan Logo" />
                        <span class="font-weight-bold section-title">Gyan Premium</span>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn-close" aria-label="Close" data-bs-dismiss="modal" (click)="closeGetproModal()"></button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-4 center-border text-center">
                        <div class="GetPro-header-font">Basic</div>
                        <p class="GetPro-p-font">Free, for trying things out.</p>
                        <ul class="list-unstyled">
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Rapid Gyan</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Article Network</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Number of Queries 5</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">❌</span>
                                <span class="text col-9">Advanced</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">❌</span>
                                <span class="text col-9">MDS Network</span>
                            </li>
                        </ul>
                        <div class="d-block text-center mt-4">
                            <button class="GetPro-btn-custom btn btn-primary" (click)="closeGetproModal()">Select Plan</button>
                        </div>
                    </div>
                    <div class="col-4 center-border text-center">
                        <div class="GetPro-header-font">Standard</div>
                        <p class="GetPro-p-font">Free, for trying things out.</p>
                        <ul class="list-unstyled">
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Rapid Gyan</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Article Network</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Number of Queries 5</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">❌</span>
                                <span class="text col-9">Advanced</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">❌</span>
                                <span class="text col-9">MDS Network</span>
                            </li>
                        </ul>
                        <div class="d-block text-center mt-4">
                            <button class="GetPro-btn-custom btn btn-primary" (click)="closeGetproModal()">Select Plan</button>
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        <div class="GetPro-header-font">Premium</div>
                        <p class="GetPro-p-font">Free, for trying things out.</p>
                        <ul class="list-unstyled">
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Rapid Gyan</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Article Network</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">✔️</span>
                                <span class="text col-9">Number of Queries 5</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">❌</span>
                                <span class="text col-9">Advanced</span>
                            </li>
                            <li class="list-item">
                                <span class="symbol">❌</span>
                                <span class="text col-9">MDS Network</span>
                            </li>
                        </ul>
                        <div class="d-block text-center mt-4">
                            <button class="GetPro-btn-custom btn btn-primary" (click)="closeGetproModal()">Select Plan</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-signup></app-signup>
